import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import AppgInput from '@/components/custom/AppgInput.vue';
import { toRefs } from 'vue';
export default {
  __name: 'AppgSelectBox',
  props: {
    valid: {
      type: Boolean,
      default: true
    },
    invalidMessage: {
      type: String,
      default: ''
    },
    _class: {
      type: String,
      default: 'col-md-12'
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: [Object, String, Boolean, Number],
      default: null
    },
    options: {
      type: Array,
      default: []
    },
    isFormGroup: {
      type: Boolean,
      description: 'Whether is form-group className',
      default: true
    },
    changeEvent: {
      type: [Function, Object],
      default: null
    },
    isChange: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const props = __props;
    const {
      _class,
      label,
      required,
      modelValue,
      options,
      valid,
      invalidMessage
    } = toRefs(props);
    const input = value => {
      if (props.changeEvent) {
        props.changeEvent(value);
      }
      if (props.isChange) {
        emits('change', value);
      } else {
        // modelValue.value = value;
        emits('update:modelValue', value);
      }
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(AppgInput, {
        "is-form-group": __props.isFormGroup,
        _class: _unref(_class),
        label: _unref(label),
        required: _unref(required),
        "in-valid-message": _unref(invalidMessage),
        valid: _unref(valid)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          "model-value": _unref(modelValue),
          onChange: input,
          placeholder: "전체"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([..._unref(options)], option => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: `${option.key}}`,
              label: option?.label,
              value: option.key,
              hidden: option?.hidden ?? false
            }, null, 8, ["label", "value", "hidden"]);
          }), 128))]),
          _: 1
        }, 8, ["model-value"])]),
        _: 1
      }, 8, ["is-form-group", "_class", "label", "required", "in-valid-message", "valid"]);
    };
  }
};